/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { action, observable } from 'mobx';
import { CustomSkillProjectKind } from 'src/core/stores/app/types';
import { TrainingConfigVersion } from 'src/modules/modelTraining/types/trainingTypes';

export class CustomSkillGlobalsStore {
    public id: CustomSkillProjectKind;

    @observable public trainingConfigVersions: TrainingConfigVersion[];

    constructor(id: CustomSkillProjectKind) {
        this.id = id;
    }

    @action
    public setTrainingConfigVersions(trainingConfigVersions: TrainingConfigVersion[]) {
        this.trainingConfigVersions = trainingConfigVersions;
    }
}
